import '../i18n/i18n';
import '../styles/category.scss';

import { ColourTheme } from '../types/ColourTheme';
import { Layout } from '../hoc/Layout/Layout';
import { PersonaTemplate } from '../components/Colours/PersonaTemplate/PersonaTemplate';
import React from 'react';
import i18n from 'i18next';

type State = {
  showLoading: boolean;
};

class Home extends React.PureComponent {
  state: State = {
    showLoading: true,
  };

  skipSequence = () => {
    setTimeout(() =>
      this.setState({
        showLoading: false,
      }), 1000);
  }

  render() {
    return (
      <Layout
        metaTitle={i18n.t('tabs.coloursMicro')}
        metaDesc={i18n.t('metadescr.coloursMicro.sonia')}
        theme={ColourTheme.sunflower}
      >
        <PersonaTemplate theme={ColourTheme.sunflower} />
      </Layout>
    );
  }
}

export default Home;
